<div class="d-flex justify-content-between align-content-center w-100 mb-3">
  <div>
    <span>
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1 14H15C15.2652 14 15.5196 13.8946 15.7071 13.7071C15.8946 13.5196 16 13.2652 16 13V3C16 2.73478 15.8946 2.48043 15.7071 2.29289C15.5196 2.10536 15.2652 2 15 2H1C0.734784 2 0.48043 2.10536 0.292893 2.29289C0.105357 2.48043 0 2.73478 0 3L0 13C0 13.2652 0.105357 13.5196 0.292893 13.7071C0.48043 13.8946 0.734784 14 1 14ZM1.76 10.6133L3.47333 7.76C3.56188 7.61078 3.68772 7.48716 3.83851 7.4013C3.98929 7.31544 4.15982 7.27029 4.33333 7.27029C4.50685 7.27029 4.67738 7.31544 4.82816 7.4013C4.97894 7.48716 5.10479 7.61078 5.19333 7.76L6.3 9.61333C6.31576 9.63489 6.33567 9.65308 6.35857 9.66682C6.38147 9.68056 6.40689 9.68958 6.43333 9.69333C6.45964 9.69417 6.4858 9.68924 6.50999 9.67887C6.53418 9.6685 6.5558 9.65296 6.57333 9.63333L7.24 8.84C7.33631 8.73186 7.45442 8.64532 7.58655 8.58606C7.71868 8.52681 7.86186 8.49617 8.00667 8.49617C8.15148 8.49617 8.29465 8.52681 8.42678 8.58606C8.55892 8.64532 8.67702 8.73186 8.77333 8.84L9.57333 9.79333L12.48 4.7C12.5684 4.54617 12.7143 4.43377 12.8856 4.38751C13.0569 4.34125 13.2395 4.36493 13.3933 4.45333C13.5472 4.54174 13.6596 4.68763 13.7058 4.85891C13.7521 5.0302 13.7284 5.21284 13.64 5.36667L10.4933 10.88C10.4137 11.0205 10.3011 11.1394 10.1652 11.2265C10.0293 11.3136 9.87419 11.3663 9.71333 11.38C9.55158 11.3938 9.38889 11.3682 9.23915 11.3056C9.0894 11.2429 8.95703 11.1449 8.85333 11.02L8.13333 10.16C8.11769 10.1417 8.09826 10.127 8.0764 10.1169C8.05453 10.1069 8.03074 10.1017 8.00667 10.1017C7.98259 10.1017 7.9588 10.1069 7.93694 10.1169C7.91507 10.127 7.89565 10.1417 7.88 10.16L7.15333 11.0333C7.05029 11.1548 6.9199 11.25 6.77288 11.3113C6.62587 11.3725 6.46642 11.398 6.30764 11.3856C6.14886 11.3733 5.99527 11.3234 5.85951 11.2401C5.72375 11.1569 5.60967 11.0426 5.52667 10.9067L4.47333 9.16C4.4595 9.13499 4.43921 9.11415 4.41459 9.09963C4.38997 9.08512 4.36191 9.07746 4.33333 9.07746C4.30475 9.07746 4.27669 9.08512 4.25207 9.09963C4.22745 9.11415 4.20717 9.13499 4.19333 9.16L2.90667 11.3333C2.84766 11.4329 2.76377 11.5153 2.66325 11.5726C2.56273 11.6299 2.44903 11.66 2.33333 11.66C2.21278 11.6488 2.09755 11.605 2 11.5333C1.92327 11.4892 1.85609 11.4303 1.80238 11.3599C1.74867 11.2896 1.70951 11.2093 1.68717 11.1236C1.66483 11.038 1.65976 10.9488 1.67227 10.8612C1.68477 10.7735 1.7146 10.6893 1.76 10.6133Z" fill="#969696"/>
      </svg>
    </span>
    <span class="f-12 font-weight-600 ml-2 text-black">
      Activity
    </span>
  </div>
  <div class="d-flex justify-content-end align-items-center gap-2">

    <!-- <div class="dropdown-caret2">
      <select data-testid="auto-app-hire-slider-activity-view-select-1" class="custom-select" #jobtitledropdown (change)="filterByActivityType($event.target.value);updateWidth(jobtitledropdown)">
      <option value="all">All Activity Type</option>
      @for(type of activityType; track type) {
        <option value="{{type}}">{{type}}</option>
      }
    </select>
    </div> -->
  <!-- <select data-testid="auto-app-hire-slider-activity-view-select-2" class="nobg wc-form-control-activity pipeline-text-border"
    (change)="sortActivity($event.target.value)">
    <option value="recent" selected>Most Recent</option>
    <option value="oldest">Oldest</option>
  </select> -->

    <div class="dropdown-caret">
      <select data-testid="auto-app-hire-slider-activity-view-select-3" class="custom-select" #jobtitledropdown (change)="sortActivity($event.target.value);" style="width: 100px;">
        <option value="recent" selected>Most Recent</option>
        <option value="oldest">Oldest</option>
      </select>
    </div>
</div>
</div>

<div class="col paddingBottom" [class.paddingBottom]="candidateActivity.length>0">
  @if(candidateActivity) {
    <!-- <div class="activities-list mt-4"> -->
      @for(activity of candidateActivity; track activity; let i=$index) {
      <div class="py-2 bb-1">
        <span class="f-12 text-black font-weight-500 mb-1">
          <span class="text-wrap" [innerHTML]="getActivityText(activity)"></span>
        </span>
        <div class="f-12 text-9696 d-flex align-content-center text-capitalize">
          @if(currentURL?.includes('pipeline')) {
            <span class="f-12 text-9696">
              {{activity?.loginfirstname }} {{activity?.loginlastname }}
            </span>
          } @else {
      <span class="f-12 text-9696">
        {{activity?.username }}
      </span>
          }

      <span class="mx-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none">
          <circle cx="2" cy="2" r="2" fill="#E5E5E5"/>
        </svg>
      </span>
      <span>
        {{activity?.createdon | date: 'MMM dd, yyyy'}}
      </span>
      <span class="mx-2">
        <svg xmlns="http://www.w3.org/2000/svg" width="4" height="4" viewBox="0 0 4 4" fill="none">
          <circle cx="2" cy="2" r="2" fill="#E5E5E5"/>
        </svg>
      </span>
      <span>
       {{activity?.createdon | date: 'h:mm a'}}
      </span>
        </div>
      </div>
      <!-- <div class="candidate-activities">
        <div class="note">
          <div class="row mb-1">
            <div class="col d-flex">
              <div class="">
                <i class="fas fa-circle f-12 webtree-btn-1"></i>
              </div>
              <div class="col gray-text f-12 line-height-1 pl-2">
                @if(currentURL?.includes('pipeline')) {
 <p class="mb-0" class="activity">
                <span [innerHTML]="getPipelineActivityText(activity)"></span>
              </p>
                } @else{
     <p class="mb-0" class="activity">
                <span [innerHTML]="getActivityText(activity)"></span>
              </p>
                }

            </div>

          </div>
        </div>

        <div class="row mb-1">
          <div class="col d-flex">
            <div class="pr-2 d-flex align-items-stretch">
              <div class=" spacer2 pr-2 spacer-border"></div>
            </div>
            <div class="col gray-text f-12 line-height-1">
              <p class="mb-4 f-12">
                <span class="mr-3 f-12">{{activity?.username }}</span>
                <span style="position: relative;">
                  <i class="fas fa-circle mr-3" style="font-size: 5px; position: absolute; top: 7px; right: -9px;"></i>
                </span>
                <span class="mr-3">{{activity?.createdon | date: 'MMM dd, yyyy'}}</span>
                <span style="background-color: red; position: relative;" >
                  <i class="fas fa-circle mr-2" style="font-size: 5px; position: absolute; top: 7px; right: -6px;"></i>
                </span>
                <span>{{activity?.createdon | date: 'h:mm a'}}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    }
  <!-- </div> -->
}
</div>
